/**
 * Detects the current environment from the hostname
 */
export const getCurrentEnvironment = (): string => {
  const hostname = window.location.hostname;

  if (hostname.includes("dev.admin.ukarapp.com")) {
    return "development";
  }

  if (hostname.includes("test.admin.ukarapp.com")) {
    return "test";
  }

  if (hostname.includes("admin.ukarapp.com")) {
    return "production";
  }

  // Local development
  return process.env.NODE_ENV || "development";
};

export const isDevelopment = (): boolean =>
  getCurrentEnvironment() === "development";
export const isTest = (): boolean => getCurrentEnvironment() === "test";
export const isProduction = (): boolean =>
  getCurrentEnvironment() === "production";

